import React, { useState, useEffect } from "react";
import { Card, Container } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPlace, deletePlace } from "../../store/slices/place";
import DeleteModal from "./deletepopup";

export default function Places() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { placeList = [], loading } = useSelector((state) => state.place);

  const [showDelete, setShowDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteStatus, setDeleteStatus] = useState("confirm");

  const pagelimit = 25;
  const [currentPage, setCurrentPage] = useState(1);

  const fetchPlacess = async () => {
    try {
      await dispatch(getPlace()).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchPlacess();
  }, []);

  const totalPages = Math.ceil(placeList.length / pagelimit);
  const startIndex = (currentPage - 1) * pagelimit;
  const paginatedData = placeList.slice(startIndex, startIndex + pagelimit);

  // handledelete
  const handleConfirmDelete = async () => {
    try {
      setDeleteStatus("loading");

      await dispatch(deletePlace(selectedId)).unwrap();
      setDeleteStatus("success");
      setTimeout(() => {
        setShowDelete(false);
        setDeleteStatus("confirm");
      }, 1500);
    } catch (error) {
      setDeleteStatus("confirm");
    }
  };

  const changePage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  return (
    <>
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/hotel/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span
            className="breadcrumb-link inactive"
            onClick={() => navigate("/hotel/places")}
          >
            Places
          </span>
        </div>

        {/* Right: Button */}
        <button
          className="add-outlet-btn"
          onClick={() => navigate("/hotel/addplace")}
        >
          + Add Place
        </button>
      </div>

      <Container fluid className="mb-5">
        <Card style={{ border: "none" }}>
          <Card.Body className="table-border ">
            <div className="common-table-wrapper">
              <table className="common-table">
                <thead>
                  <tr>
                    <th className="text-center">#</th>
                    <th className="text-center">Image</th>
                    <th className="text-center">Place Name</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading
                    ? [...Array(6)].map((_, index) => (
                        <tr key={index}>
                          <td className="text-center">
                            <div className="skeleton skeleton-text small"></div>
                          </td>

                          <td className="text-center">
                            <div className="skeleton skeleton-image"></div>
                          </td>

                          <td className="text-center">
                            <div className="skeleton skeleton-text"></div>
                          </td>

                          <td className="text-center">
                            <div className="d-flex justify-content-center gap-2">
                              <div className="skeleton skeleton-btn"></div>
                              <div className="skeleton skeleton-btn"></div>
                            </div>
                          </td>
                        </tr>
                      ))
                    : paginatedData.map((place, index) => (
                        <tr key={place._id}>
                          <td className="text-center">
                            {(currentPage - 1) * pagelimit + index + 1}
                          </td>

                          <td className="text-center">
                            {place.image ? (
                              <img
                                src={place.image}
                                className="place-thumb"
                                alt={place.name}
                              />
                            ) : (
                              <span className="no-image">—</span>
                            )}
                          </td>

                          <td className="text-center">{place.name}</td>

                          <td className="text-center">
                            <div className="action-btn-group">
                              <button
                                className="action-btn edit-btn"
                                onClick={() =>
                                  navigate(`/hotel/edit-place/${place._id}`)
                                }
                              >
                                <FaEdit size={14} />
                              </button>

                              <button
                                className="action-btn delete-btn"
                                onClick={() => {
                                  setSelectedId(place._id);
                                  setShowDelete(true);
                                }}
                              >
                                <FaTrash size={14} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <div className="d-flex justify-content-end mt-3 gap-2">
                <button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => changePage(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="previous-btn"
                >
                  Previous
                </button>

                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i}
                    size="sm"
                    className={`button-between ${
                      currentPage === i + 1 ? "active-page" : ""
                    }`}
                    onClick={() => changePage(i + 1)}
                  >
                    {i + 1}
                  </button>
                ))}

                <button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => changePage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="next-btn "
                >
                  Next
                </button>
              </div>
            )}
          </Card.Body>
        </Card>
      </Container>

      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onConfirm={handleConfirmDelete}
        status={deleteStatus}
      />
    </>
  );
}
